// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panorama-invoice-status[data-v-5924cb0c] {\n  font-weight: 700;\n}", "",{"version":3,"sources":["webpack://assets/modules/panorama/components/render-panorama-invoice-status-value.vue","webpack://render-panorama-invoice-status-value.vue"],"names":[],"mappings":"AACA;EACE,gBAAA;ACAF","sourcesContent":["\n.panorama-invoice-status {\n  font-weight: 700;\n}\n",".panorama-invoice-status {\n  font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
